module.exports = __webpack_public_path__ + "static/media/bcjavascript.fa9f1bee.png";